import Api from '@services/api';
import axios from 'axios';

export default {
  getReply(text) {
    return Api()
      .post('/ai/generate', text)
      .then((res) => res.data);
  },
  generateReplyForReview(id, model) {
    return Api()
      .get(`/ai/generate/review/${id}`, {params: {model}})
      .then((res) => res.data);
  },
  fetchModels() {
    return axios.get('https://openrouter.ai/api/v1/models').then((res) => res.data.data);
  },
};
